import type {PublicMethodUtils} from '@wix/document-services-types'
import type {GlobalStylesPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<GlobalStylesPublicAPI> {
    const {
        extensionPublicAPI: {dataManipulation, getter}
    } = publicMethodUtils

    return {
        methods: {
            global: {
                cssStyle: {
                    getPointer: getter('style.global.getPointer'),
                    create: dataManipulation('style.global.create', {
                        getReturnValueMethodPath: 'style.global.getNewGlobalStylePointer'
                    }),
                    get: getter('style.global.get'),
                    update: dataManipulation('style.global.update'),
                    remove: dataManipulation('style.global.remove'),
                    delete: dataManipulation('style.global.delete'),
                    getComponentsUsingStyle: getter('style.global.getComponentsUsingStyle'),
                    isGlobalStyle: getter('style.global.isGlobalStyle'),
                    replace: dataManipulation('style.global.replace'),
                    list: getter('style.global.list'),
                    definition: {
                        get: getter('style.global.definition.get'),
                        update: dataManipulation('style.global.definition.update'),
                        addInnerElementStyle: dataManipulation('style.global.definition.addInnerElementStyle')
                    }
                }
            }
        }
    }
}
